import { Api } from 'utils';

class DriverService {

	static get = async (params?: any) => Api.createResponse('client/drivers',params);
	static delete = async (params?: any) => Api.createResponse('client/drivers/delete',params);
	static save = async (params?: any) => Api.createResponse('client/drivers/save',params);
	static changeStatus = async (params?: any) => Api.createResponse('client/drivers/change-status',params);
	static changeOwner = async (params?: any) => Api.createResponse('client/drivers/change-owner',params);
	static view = async (params?: any) => Api.createResponse('client/drivers/view',params);
	static validate = async (params?: any) => Api.createResponse('client/drivers/validate',params);
	static readDocument = async (params?: any) => Api.createResponse('client/drivers/read-document',params);
	
	static invitations = {
		get: async (params?: any) => Api.createResponse('client/drivers/invitations',params),
		send: async (params?: any) => Api.createResponse('client/drivers/invitations/send',params),
		delete: async (params?: any) => Api.createResponse('client/drivers/invitations/delete',params)
	}
}

export default DriverService;